import {AssessmentResultListModel} from "~~/package/mapper/assessment/model/AssessmentResultListModel";
import {AssessmentResultDetailModel} from "~~/package/mapper/assessment/model/AssessmentResultDetailModel";
import {AssessmentAvailableCountModel} from "~~/package/mapper/assessment/model/AssessmentAvailableCountModel";
import {AssessmentKnowledgeSummaryModel} from "~~/package/mapper/assessment/model/AssessmentKnowledgeSummaryModel";
import type AssessmentResponse from "~~/package/apis/assessment/response/AssessmentResponse";
import {TaskModel} from "~~/package/mapper/learning/model/TaskModel";
import {ProvisionStatusModel} from "~~/package/mapper/assessment/model/ProvisionStatusModel";
import type ProvisionStatusResponse from "~~/package/apis/assessment/response/ProvisionStatusResponse";

export class AssessmentHelper {
    public static mappingAssessmentResultList(assessmentResultList: AssessmentResultListModel): AssessmentResultListModel {
        return AssessmentResultListModel.create(assessmentResultList);
    }

    public static mappingAssessmentResultDetail(assessmentResultDetail: AssessmentResultDetailModel): AssessmentResultDetailModel {
        return AssessmentResultDetailModel.create(assessmentResultDetail);
    }

    public static mappingAssessmentAvailableCountData(assessmentAvailableCount: AssessmentAvailableCountModel): AssessmentAvailableCountModel {
        return AssessmentAvailableCountModel.create(assessmentAvailableCount);
    }

    public static mappingAssessmentListData(assessment: AssessmentResponse): TaskModel {
        return TaskModel.create({
            ...assessment,
            id: assessment.taskId
        });
    }

    public static mappingAssessmentKnowledgeSummaryListData(assessment: AssessmentKnowledgeSummaryModel): AssessmentKnowledgeSummaryModel {
        return AssessmentKnowledgeSummaryModel.create(assessment);
    }

    public static mappingProvisionStatus(provisionStatus: ProvisionStatusResponse): ProvisionStatusModel {
        return ProvisionStatusModel.create(provisionStatus);
    }
}
